const MS_PER_DAY = 86_400_000;
const DAYS_PER_YEAR = 365;

const localDayNumber = (date: Date): number =>
    Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()) / MS_PER_DAY;

export const localDaysBetween = (from: Date, to: Date): number =>
    localDayNumber(to) - localDayNumber(from);

const isUsableMileage = (value: number | null | undefined): value is number =>
    typeof value === 'number' && Number.isFinite(value) && value >= 0;

interface LastServiceMileageInputs {
    currentMileage: number | null | undefined;
    annualMileage: number | null | undefined;
    lastServiceDate: Date | null | undefined;
    today?: Date;
}

export const estimateLastServiceMileage = ({
    currentMileage,
    annualMileage,
    lastServiceDate,
    today = new Date(),
}: LastServiceMileageInputs): number | null => {
    if (!isUsableMileage(currentMileage)) return null;
    if (!lastServiceDate || Number.isNaN(lastServiceDate.getTime())) return null;

    const elapsedDays = localDaysBetween(lastServiceDate, today);
    if (elapsedDays < 0) return null;
    if (elapsedDays === 0) return currentMileage;
    if (!isUsableMileage(annualMileage)) return null;

    const estimate = Math.round(currentMileage - annualMileage * (elapsedDays / DAYS_PER_YEAR));
    return Math.min(currentMileage, Math.max(0, estimate));
};
